<template>
  <NuxtLayout name="base" :page="page">
    <LayoutContainer>
      <UtilityHeadline
        :class="{
          'dbc-text-color-primary': client !== 'cab' && client !== 'flinkster',
        }"
        text="Sitemap"
        :level="2"
      />
      <ul>
        <li v-for="link in sitemapLinks">
          <NuxtLink :to="link.path">{{ link.title }}</NuxtLink>
        </li>
      </ul>
    </LayoutContainer>
  </NuxtLayout>
</template>

<script setup lang="ts">
const client = useRuntimeConfig().public.client
const route = useRoute()
const { locales } = useI18n()

const { setLocale } = useI18n()
const locale = route.params.locale as string
setLocale(locale as 'de' | 'en')

const sitemapLinks = await useFetchSitemapLinks()

const localizations = locales.value
  ?.filter(({ code }) => code !== locale)
  .map(({ code }) => {
    if (code !== locale) {
      return {
        id: 0,
        title: 'Sitemap',
        path: 'sitemap',
        locale: code,
      }
    }
  }) as localization[]

const page: Page = {
  id: 0,
  title: 'Sitemap',
  path: '/sitemap',
  description: 'Sitemap',
  content: [],
  localizations: localizations,
  locale: locale as string,
}

useHead({
  title: 'Sitemap',
})

usePageHead(page)
</script>
